import { env } from '@/lib/env';

/**
 * Base URL for incidents/ticket routes (POST /integrations/servicenow/inbound, /tickets, /code, …).
 *
 * When REACT_APP_BACKEND_URL points at aistudio (:8004) for chat-only local dev, ticket routes
 * still live on incidentsapi (:8001) or the local gateway (:8088/backend/api).
 */
export function getIncidentsApiBase() {
  const explicit = (env('REACT_APP_INCIDENTS_API_URL') || '').replace(/\/$/, '');
  if (explicit) return explicit;

  const backend = (env('REACT_APP_BACKEND_URL') || '').replace(/\/$/, '');
  if (!backend) return '';

  if (backend.endsWith('/backend')) {
    return `${backend}/api`;
  }

  if (backend.includes(':8001')) {
    return backend;
  }

  // Prod/stage API gateway root (already includes /api, not aistudio chat host).
  if (backend.endsWith('/api') && !backend.includes(':8004')) {
    return backend;
  }

  if (backend.includes('localhost') || backend.includes('127.0.0.1')) {
    return 'http://localhost:8001/api';
  }

  return `${backend}/api`;
}

/** Resolved once at load — use for tickets, code, inbound, reports API calls. */
export const INCIDENTS_API = getIncidentsApiBase();
